import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ChatDetailLayout, ChatFooter, ChatHeader, ChatMessages } from 'features/chat';
import { useChatroomsSearchParams, useNavigateToChat, useNavigateToCreateChat, useRedirectToChatroom } from '../hooks';

const PageChatDetail = () => {
  const { chatId } = useRequiredParams<{ chatId: string }>();
  const navigateToChat = useNavigateToChat();
  const navigateToCreateChat = useNavigateToCreateChat();
  const searchParamsOptions = useChatroomsSearchParams();
  const redirectToChatroom = useRedirectToChatroom();

  return (
    <AppLayout fitCenterContent>
      <ChatDetailLayout
        footer={(chatroomId) => <ChatFooter chatroomId={chatroomId} />}
        header={(chatroom) => <ChatHeader chatroom={chatroom} onChatDeleted={navigateToChat} />}
        id={chatId}
        onChatDeleted={navigateToChat}
        onChatRoomClicked={redirectToChatroom}
        onCreateChatClicked={navigateToCreateChat}
        searchParamsOptions={searchParamsOptions}
      >
        {({ chatroom }) => <ChatMessages chatroom={chatroom} key={chatroom.id} />}
      </ChatDetailLayout>
    </AppLayout>
  );
};

export default PageChatDetail;
